export default __webpack_public_path__ + "static/media/fresh23.4be444c6.jpg";